import React, { useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { LoginModalContext } from '../context/LoginModalContext';

const UserRoute = ({ children }) => {
  const user = useSelector((state) => state.user);
  const openLoginModal = useContext(LoginModalContext);
  const location = useLocation();

  useEffect(() => {
    if (!user.uid) openLoginModal(location.pathname);
  }, [user.uid]);

  return user.uid ? children : null;
};

UserRoute.propTypes = {
  children: PropTypes.node.isRequired
};

export default UserRoute;
